import { styled as muiStyled, TableCell, TableRow, Table } from '@mui/material';

import type { StyledTableCellProps } from './types';
import { FinancialColumnId } from '../../constants/columns';

const StyledTableCell = muiStyled(TableCell, {
  shouldForwardProp: prop => prop !== 'columnId',
})<StyledTableCellProps>(({ columnId }) => ({
  width: columnId === FinancialColumnId.PaymentDate ? '120px' : 'auto',
  paddingLeft: 0,
}));

const StyledTableRow = muiStyled(TableRow)({
  '&:last-child td, &:last-child th': {
    border: 0,
  },
});

const StyledTable = muiStyled(Table)({
  minWidth: 650,
});

const Footer = muiStyled('div')({
  display: 'flex',
  position: 'relative',
  minHeight: '90px',
  alignItems: 'flex-end',
  gap: '64px',
  paddingBottom: '16px',
});

export { StyledTableCell, StyledTableRow, Footer, StyledTable };
